import React from "react";
import dashboardImage from "../../Assets/Images/seekjob/manner.png";
// Import your GIF here. Make sure the path is correct.
import yourGif from "../../Assets/Images/seekjob/dd5291d62e6c9c911a95fa40964687c6b6a8e396.gif"; // <--- IMPORTANT: Replace with your actual GIF path
import sectionBackground from "../../Assets/Images/seekjob/background.png"; // Make sure this path is correct
import intelligentDiscoveryImage from "../../Assets/Images/seekjob/new-frame.png";
import DiscoveryImg from "../../Assets/Images/seekjob/frameimage.png";
import lastOne from "../../Assets/Images/seekjob/last.png";
import endOne from "../../Assets/Images/seekjob/end.png"; // <--- IMPORTANT:
import Button from "./ui/Button";
import { useNavigate } from "react-router-dom";
// import intelligentDiscovery from "../../Assets/Images/seekjob/new-frameimage.png"; // <--- IMPORTANT: Replace with your actual path
function CtaSection() {
  const navigate = useNavigate()
  const handleStartSuccessStory = () => {
    console.log("Starting success story");
  };
  return (
    <section className="tw-bg-gradient-to-b tw-from-[#081933] tw-to-[#184B99] tw-rounded-[12px] tw-relative tw-overflow-hidden">
      <img
        src="/images/img_image_8.png"
        alt="Background"
        className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
      />
      {/* Blue shading overlay */}
      <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-b tw-from-[#081933]/70 tw-to-[#184B99]/70"></div>
      <div className="tw-relative tw-z-10 tw-py-8 sm:tw-py-12 tw-px-6 sm:tw-px-32 tw-text-center">
        <h2
          className="tw-font-inter tw-font-semibold tw-text-[40px] sm:tw-text-[64px] tw-leading-[48px] sm:tw-leading-[77px] tw-text-global-6 tw-mb-3 sm:tw-mb-[10px]"
          style={{ textShadow: "0px 0px 16px rgba(255, 255, 255, 0.5)" }}
        >
          Curious how it all works together?
        </h2>

        <div className="tw-mt-3 tw-text-[16px] tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center tw-space-y-4 sm:tw-space-y-0 sm:tw-space-x-4">
          <button onClick={() => navigate("/sign-up")} className="tw-inline-block tw-bg-gradient-to-r tw-from-[#0843FE] tw-to-[#4995FB] tw-text-white tw-font-medium tw-py-3 tw-px-8 tw-rounded-md tw-transition tw-duration-300 tw-ease-in-out tw-border-0 tw-text-center">
            Experience SeekJobs
          </button>
          <button onClick={() => navigate("/#ContactUs")} className="tw-bg-white tw-text-[#114efe] tw-border tw-border-white tw-font-semibold tw-py-3 tw-px-8 tw-rounded-lg tw-transition tw-duration-300 tw-text-center">
            Book a Demo
          </button>
        </div>
      </div>
    </section>

  );
}

export default CtaSection;
